<template>
  <div>
    <v-row class="mx-6 mt-4">
      <v-col cols="6">
        <v-text-field
          v-model="name"
          label="プリセット名"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="code"
          label="テスト記号"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="4">
        <v-select
          v-model="subjectId"
          :items="subjects"
          item-text="name"
          item-value="id"
          label="教科"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-select
          v-model="gradeId"
          :items="grades"
          item-text="name"
          item-value="id"
          label="学年"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-select
          v-model="periodId"
          :items="periods"
          item-text="name"
          item-value="id"
          label="テスト時期"
          clearable
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="6" class="d-flex align-center">
        <v-checkbox
          v-model="isShingaku"
          label="進学教材用"
        ></v-checkbox>
      </v-col>
      <!-- 進学教材プリセットはアカウントの年度(R8/R9)で出し分けるため、どの年度の進学教材かを設定する -->
      <v-col cols="6" v-if="isShingaku">
        <v-select
          v-model="fiscalYearWestern"
          :items="fiscalYearOptions"
          label="年度（進学教材）"
          hint="未設定の場合はR8として扱います"
          persistent-hint
          clearable
        ></v-select>
      </v-col>
    </v-row>

    <v-btn class="mt-6 ml-6 mb-4" small color="secondary" dark @click.stop="submit">保存</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    isNew: { type: Boolean, default: false },
  },
  computed: {
    name: {
      get() { return this.$store.state.preset.name },
      set(value) { this.$store.commit('preset/setName', { name: value }) }
    },
    code: {
      get() { return this.$store.state.preset.code },
      set(value) { this.$store.commit('preset/setCode', { code: value }) }
    },
    subjectId: {
      get() { return this.$store.state.preset.subjectId },
      set(value) { this.$store.commit('preset/setSubjectId', { subjectId: value }) }
    },
    gradeId: {
      get() { return this.$store.state.preset.gradeId },
      set(value) { this.$store.commit('preset/setGradeId', { gradeId: value }) }
    },
    periodId: {
      get() { return this.$store.state.preset.periodId },
      set(value) { this.$store.commit('preset/setPeriodId', { periodId: value }) }
    },
    fiscalYearWestern: {
      get() { return this.$store.state.preset.fiscalYearWestern },
      set(value) { this.$store.commit('preset/setFiscalYearWestern', { fiscalYearWestern: value }) }
    },
    // R8(2026年度)から、今年度の2年先までを選べるようにする
    fiscalYearOptions() {
      const today = new Date()
      const currentFiscalYear = today.getFullYear() - (today.getMonth() < 3 ? 1 : 0)
      const options = []
      for (let year = 2026; year <= currentFiscalYear + 2; year++) {
        options.push({ text: `R${year - 2018}（${year}年度）`, value: year })
      }
      return options
    },
    isShingaku: {
      get() { return this.$store.state.preset.isShingaku },
      set(value) { this.$store.commit('preset/setIsShingaku', { isShingaku: value }) }
    },
    subjects() {
      const allSubjects = this.$store.state.master.allSubjects
      return allSubjects ? allSubjects.filter(s => s.ancestry === null) : []
    },
    grades() {
      return this.$store.state.master.allGrades || []
    },
    periods() {
      return this.$store.state.master.allPeriods || []
    },
  },

  methods: {
    async submit() {
      const res = await this.$store.dispatch('preset/validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else this.$emit('submit')
    },
  },
}
</script>

<style lang="stylus" scoped>
</style>
